<template>
	<div>
		<NavHeader />


		<div class="main-header-content">
			<div class="container">
				<h3>Promotions</h3>
			</div>
		</div>

		<div class="divider"></div>


		<div class="container">
			<div class="information-detail">
				<div class="sidebar">
					<ul class="main-menu">
						<li class="main-list">
							<h2 class="list-header pdt0">Promotions <i class="material-icons">expand_more</i></h2>

							<ul class="sub-menu">
								<li v-for="item in promotionCollection" :key="item.Id"><a v-bind:class="{ active: item.Active }" @click="onTitleClick(item.Id)">{{item.Title}}</a></li>
							</ul>
						</li>
					</ul>
				</div>

				<div class="information-content">
					<img :src="'api/image/promotion/'+vModelPromo.Id" :alt="vModelPromo.Title" :title="vModelPromo.Title" class="info-image" />

					<h3 class="info-header red">{{vModelPromo.Title}}</h3>
					<div v-html="vModelPromo.Description"></div>
					<div v-if="vModelPromo.HasPdf">
					  <br>
						<a :href="'api/image/promotion/pdf/'+vModelPromo.Id" target="_blank">Terms & Conditions</a>
					</div>
						
				</div>
			</div>
		</div>


		<div class="divider"></div>







	</div>
</template>
<script>
	import DownloadApp from "../../shared/commercial/DownloadApp.vue";
	import NavHeader from "../../shared/commercial/NavHeader.vue";
	import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";
	import ListService from "../../services/list";


	export default {
		name: "Dashboard",

		components: {
			DownloadApp,
			NavHeader,
			SignUpFooter
		},


		created() {},
		beforeRouteEnter(to, from, next) {
			Promise.all([
				ListService.get('list/promotion/all')
			]).then(responses => {
				next(vm => {
				
					vm.promotionCollection = responses[0].body;
					if (to.params.id == undefined && vm.promotionCollection.length != 0) {
						vm.vModelPromo = vm.promotionCollection[0];
						vm.vModelPromo.Active = true;
					} else if (to.params.id && vm.promotionCollection.length != 0) {
						vm.vModelPromo = vm.promotionCollection.filter(x => {
							return (x.Id == to.params.id);
						})[0];
						vm.vModelPromo.Active = true;
					}
				});
			});
		},
		data() {
			return {
				ExchangeRateCollection: [],
				RecentTransactionCollection: [],
				NotificationCollection: [],

				RecipientCollection: null,
				ClassBadge: {
					'badge-yellow': true
				},
				itemTemplate: '<div class="m-b-sm m-t-sm">#:data.Fullname# <br/><img style="width:24px;" src="static/img/flags/#:data.FlagCode#.png" />#:data.CountyName#<br/> #:data.PayoutMode#</div>',
				vModel: {
					RecipientId: null
				},
				promotionCollection: [],
				vModelPromo: {
					Id: null,
					Title: null,
					Description: null,
					Active: false
				}
			};
		},
		methods: {
			onTitleClick: function (imageId) {
				
				this.promotionCollection.forEach(x=>{
					x.Active = false;
				});

				this.vModelPromo = this.promotionCollection.filter(x => {
					return (x.Id == imageId);
				})[0];
				this.vModelPromo.Active = true;
			},

			badgeColor: function (statusid) {

				var color = {
					'badge-yellow': true
				}

				switch (statusid) {
					case 1:
					case 2:
					case 3:
					case 4:
					case 6:
					case 7:
					case 8:
					case 14:
					case 15:
						color = {
							'badge-yellow': true
						}
						break;
					case 5:
						color = {
							'badge-green': true
						}
						break;
					case 9:
					case 11:
					case 12:
					case 19:
					case 20:
					case 21:
						color = {
							'badge-red': true
						}
						break;

					case 10:
					case 13:
						color = {
							'badge-grey': true
						}
						break;
				}

				return color;

			},
			sendMoney: function (e) {
				window.Vue.$router.push(e.sender._old);
			},
			pullpromotion: function () {

			}
		}
	};
</script>
